<template>
    <section id="features" class="features">
        <div class="container" data-aos="fade-up">
            <ul class="nav nav-tabs row gy-4 d-flex">
                <li class="nav-item col-6 col-md-4 col-lg-2">
                    <a class="nav-link active show" data-bs-toggle="tab" data-bs-target="#tab-0">
                        <i class="bi bi-info-circle color-cyan"></i>
                        <h4>{{ $t('infoNav1') }}</h4>
                    </a>
                </li>
                <li class="nav-item col-6 col-md-4 col-lg-2">
                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-1">
                        <i class="bi bi-bell color-1"></i>
                        <h4>{{ $t('infoNav2') }}</h4>
                    </a>
                </li>
                <li class="nav-item col-6 col-md-4 col-lg-2">
                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-2">
                        <i class="bi bi-bag color-2"></i>
                        <h4>{{ $t('infoNav3') }}</h4>
                    </a>
                </li>
                <li class="nav-item col-6 col-md-4 col-lg-2">
                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-3">
                        <i class="bi bi-clipboard-data color-3"></i>
                        <h4>{{ $t('infoNav4') }}</h4>
                    </a>
                </li>
                <li class="nav-item col-6 col-md-4 col-lg-2">
                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-4">
                        <i class="bi bi-people color-4"></i>
                        <h4>{{ $t('infoNav5') }}</h4>
                    </a>
                </li>
                <li class="nav-item col-6 col-md-4 col-lg-2">
                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-5">
                        <i class="bi bi-search color-teal"></i>
                        <h4>{{ $t('infoNav6') }}</h4>
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" id="tab-0">
                    <div class="row gy-4 featured-services">
                        <div class="col-xl-3 col-md-3" data-aos="zoom-out">
                            <div class="service-item position-relative">
                                <h4>{{ $t('infoNav1_1') }}</h4>
                                <table class="table table-hover">
                                    <tbody>
                                        <tr><th style="text-align: left;">{{ $t('infoNav1_1_1') }}</th></tr>
                                        <tr><th>{{ yardTraffic.tmlTruckIn }}{{ $t('infoNav1_1_2') }}</th></tr>
                                        <tr><th style="text-align: left;">{{ $t('infoNav1_1_3') }}</th></tr>
                                        <tr><th>{{ yardTraffic.tmlTruckOut }}{{ $t('infoNav1_1_2') }}</th></tr>
                                    </tbody>
                                </table>
                                <p v-if="yardTraffic.tmlStatus === '현 야드 상태 양호함'" style="font-weight: bold;color: green;">{{ yardTraffic.tmlStatus }}</p>
                                <p v-if="yardTraffic.tmlStatus === '현 야드 상태 혼잡'" style="font-weight: bold;color: blue;">{{ yardTraffic.tmlStatus }}</p>
                                <p v-if="yardTraffic.tmlStatus === '현 야드 상태 매우 혼잡'" style="font-weight: bold;color: red;">{{ yardTraffic.tmlStatus }}</p>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-3" data-aos="zoom-out">
                            <div class="service-item position-relative">
                                <h4>{{ $t('infoNav1_2') }}</h4>
                                <table class="table table-hover">
                                    <tbody>
                                        <tr><th style="text-align: left;">{{ $t('infoNav1_2_1') }}</th></tr>
                                        <tr><th>{{ yardTraffic.turnTimeIn }}{{ $t('infoNav1_2_2') }}</th></tr>
                                        <tr><th style="text-align: left;">{{ $t('infoNav1_2_3') }}</th></tr>
                                        <tr><th>{{ yardTraffic.turnTimeOut }}{{ $t('infoNav1_2_2') }}</th></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-6" data-aos="zoom-out" data-aos-delay="400">
                            <div class="service-item position-relative">
                                <h4>{{ $t('infoNav1_3') }}</h4>
                                <div class="table-responsive">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>{{ $t('infoNav1_3_1') }}</th>
                                            <th>{{ $t('infoNav1_3_2') }}</th>
                                            <th>{{ $t('infoNav1_3_3') }}</th>
                                            <th>{{ $t('infoNav1_3_4') }}</th>
                                            <th>{{ $t('infoNav1_3_5') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr :key='i' v-for='(data, i) in vsl'>
                                            <td>{{ data.berthNo }}</td>
                                            <td>{{ data.vsl }}</td>
                                            <td>{{ data.cutOffDate }}</td>
                                            <td>{{ data.etbDate }}</td>
                                            <td>{{ data.etdDate }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12 col-md-12" data-aos="zoom-out" data-aos-delay="400">
                            <div class="service-item position-relative">
                                <h4>{{ $t('infoNav1_4') }}</h4>
                                <div class="table-responsive">
                                    <table class="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <td>OPER</td>
                                                <td :key='i' v-for='(data, i) in emptyCont'>{{ data.oper }}</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>20GP</td>
                                                <td :key='i' v-for='(data, i) in emptyCont'>{{ data.cnt20gp }}</td>
                                            </tr>
                                            <tr>
                                                <td>40GP</td>
                                                <td :key='i' v-for='(data, i) in emptyCont'>{{ data.cnt40gp }}</td>
                                            </tr>
                                            <tr>
                                                <td>40HC</td>
                                                <td :key='i' v-for='(data, i) in emptyCont'>{{ data.cnt40hc }}</td>
                                            </tr>
                                            <tr>
                                                <td>45HC</td>
                                                <td :key='i' v-for='(data, i) in emptyCont'>{{ data.cnt45hc }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <p> {{ $t('infoNav1_4_1') }}</p>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-2" data-aos="zoom-out" data-aos-delay="400">
                            <div class="service-item position-relative">
                                <h4>{{ $t('infoNav1_5') }}</h4>
                                <p>{{ weather.strdDate }} {{ weather.strdTime }} </p>
                                <p>{{ $t('infoNav1_5_1').split('\n')[0] }}<br>{{ $t('infoNav1_5_1').split('\n')[1] }}</p>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-2" data-aos="zoom-out" data-aos-delay="400">
                            <div class="service-item position-relative iconBox">
                                <div class="icon"><i class="bi bi-thermometer color-red"></i></div>
                                <h6 style="color: gray;font-weight: bold;">{{ $t('infoNav1_6') }}</h6>
                                <p style="font-weight: bold;font-size: 20px;">{{ weather.t1hValue }}℃</p>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-2 col-sm-6" data-aos="zoom-out" data-aos-delay="400">
                            <div class="service-item position-relative iconBox">
                                <div class="icon"><i class="bi bi-droplet color-cyan"></i></div>
                                <h6 style="color: gray;font-weight: bold;">{{ $t('infoNav1_7') }}</h6>
                                <p style="font-weight: bold;font-size: 20px;">{{ weather.rehValue }}%</p>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-2 col-sm-6" data-aos="zoom-out" data-aos-delay="400">
                            <div class="service-item position-relative iconBox">
                                <div class="icon"><i class="bi bi-wind color-teal"></i></div>
                                <h6 style="color: gray;font-weight: bold;">{{ $t('infoNav1_8') }}</h6>
                                <p style="font-weight: bold;font-size: 20px;">{{ weather.vecName }} {{ weather.wsdValue }}m/s</p>
                            </div>
                        </div>

                        <div class="col-xl-2 col-md-2 col-sm-6" data-aos="zoom-out" data-aos-delay="400">
                            <div class="service-item position-relative iconBox">
                                <div class="icon"><i class="bi bi-cloud-rain color-blue"></i></div>
                                <h6 style="color: gray;font-weight: bold;">{{ $t('infoNav1_9') }}</h6>
                                <p style="font-weight: bold;font-size: 20px;">{{ weather.ptyName }} {{ weather.rn1Value }}mm/h</p>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-2 col-sm-6" data-aos="zoom-out" data-aos-delay="400">
                            <div class="service-item position-relative iconBox">
                                <div class="icon"><i class="bi bi-water color-indigo"></i></div>
                                <h6 style="color: gray;font-weight: bold;">{{ $t('infoNav1_10') }}</h6>
                                <p style="font-weight: bold;font-size: 20px;">{{ weather.whvValue }} m</p>
                            </div>
                        </div>
                    </div>
                </div><!-- End Tab Content 1 -->
                <div class="tab-pane" id="tab-1">
                    <div class="row gy-4">
                        <div class="col-lg-8 order-2 order-lg-1" data-aos="fade-up" data-aos-delay="100">
                            <h3>{{ $t('infoNav2_1') }}</h3>
                            <p class="more"><router-link to="/Notice/SUBJECT">{{ $t('infoNav_more') }}</router-link></p>
                            <br>
                            <p v-if="this.notice.length === 0">{{ $t('infoNav2_1_Empty') }}</p>
                            <ul :key='i' v-for='(data, i) in notice' class="list">
                                <li data-aos="fade-up"><i class="bi bi-check-circle-fill"></i>&nbsp;&nbsp;<a class="subject" @click="detail(data.commNo, 'NOTICE')">{{data.commSubject}}</a></li>
                            </ul>
                        </div>
                        <div class="col-lg-4 order-1 order-lg-2 text-center" data-aos="fade-up" data-aos-delay="200">
                            <img v-bind:src="tabNotice" alt="" class="img-fluid">
                        </div>
                    </div>
                </div><!-- End Tab Content 1 -->
                <div class="tab-pane" id="tab-2">
                    <div class="row gy-4">
                        <div class="col-lg-8 order-2 order-lg-1">
                            <h3>{{ $t('infoNav3_1') }}</h3>
                            <p class="more"><router-link to="/Tender/SUBJECT">{{ $t('infoNav_more') }}</router-link></p>
                            <br>
                            <p v-if="this.tender.length === 0">{{ $t('infoNav2_1_Empty') }}</p>
                            <ul :key='i' v-for='(data, i) in tender'>
                                <li data-aos="fade-up"><i class="bi bi-check-circle-fill"></i>&nbsp;&nbsp;<a class="subject" @click="detail(data.commNo, 'INVITATION_FOR_BIDS')">{{data.commSubject}}</a></li>
                            </ul>
                        </div>
                        <div class="col-lg-4 order-1 order-lg-2 text-center">
                            <img v-bind:src="tabTender" alt="" class="img-fluid">
                        </div>
                    </div>
                </div><!-- End Tab Content 2 -->
                <div class="tab-pane" id="tab-3">
                    <div class="row gy-4">
                        <div class="col-lg-8 order-2 order-lg-1">
                            <h3>{{ $t('infoNav4_1') }}</h3>
                            <p class="more"><router-link to="/Reference/SUBJECT">{{ $t('infoNav_more') }}</router-link></p>
                            <br>
                            <p v-if="this.reference.length === 0">{{ $t('infoNav2_1_Empty') }}</p>
                            <ul :key='i' v-for='(data, i) in reference'>
                                <li data-aos="fade-up"><i class="bi bi-check-circle-fill"></i>&nbsp;&nbsp;<a class="subject" @click="detail(data.commNo, 'ARCHIVE')">{{data.commSubject}}</a></li>
                            </ul>
                        </div>
                        <div class="col-lg-4 order-1 order-lg-2 text-center">
                            <img v-bind:src="tabData" alt="" class="img-fluid">
                        </div>
                    </div>
                </div><!-- End Tab Content 2 -->
                <div class="tab-pane" id="tab-4">
                    <div class="row gy-4">
                        <div class="col-lg-8 order-2 order-lg-1">
                            <h3>{{ $t('infoNav5_1') }}</h3>
                            <p class="more"><router-link to="/Recruit/SUBJECT">{{ $t('infoNav_more') }}</router-link></p>
                            <br>
                            <p v-if="this.recruit.length === 0">{{ $t('infoNav2_1_Empty') }}</p>
                            <ul :key='i' v-for='(data, i) in recruit'>
                                <li data-aos="fade-up"><i class="bi bi-check-circle-fill"></i>&nbsp;&nbsp;<a class="subject" @click="detail(data.commNo, 'RECRUIT')">{{data.commSubject}}</a></li>
                            </ul>
                        </div>
                        <div class="col-lg-4 order-1 order-lg-2 text-center">
                            <img v-bind:src="tabRecruit" alt="" class="img-fluid">
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="tab-5">
                    <div class="row gy-4">
                        <div class="col-lg-8 order-2 order-lg-1">
                            <h3>{{ $t('infoNav6_1') }}</h3><br>
                            <h4 class="title">{{ $t('infoNav6_1_1') }}</h4>
                            <div class="search-form d-flex">
                                <input type="text" class="form-control" v-model="contNo" maxlength="11" :placeholder="$t('container3')" @keyup.enter="container">
                                <button class="searchButton" @click="container"><i class="bi bi-search"></i></button>
                            </div>
                            <br><br>
                            <h4 class="title">{{ $t('infoNav6_1_2') }}</h4>
                            <div class="search-form d-flex">
                                <select class="form-select" v-model="this.searchBoard">
                                    <option value="Notice">{{ $t('infoNav6_1_4') }}</option>
                                    <option value="Tender">{{ $t('infoNav6_1_5') }}</option>
                                    <option value="Recruit">{{ $t('infoNav6_1_6') }}</option>
                                    <option value="Reference">{{ $t('infoNav6_1_7') }}</option>
                                </select>
                                <select class="form-select" v-model="this.searchSelect">
                                    <option value="SUBJECT">{{$t('notice7')}}</option>
                                    <option value="USER_NAME">{{$t('notice8')}}</option>
                                </select>
                                <input type="text" class="form-control" v-model="this.searchKeyword" :placeholder="$t('notice9')" @keyup.enter="board">
                                <button class="searchButton" @click="board"><i class="bi bi-search"></i></button>
                            </div>
                            <br><br>
                            <h4 class="title">{{ $t('infoNav6_1_3') }}</h4>
                            <div class="search-form d-flex">
                                <select v-model="this.searchType" class="form-select">
                                    <option value="carNo">{{ $t('copinoSend3') }}</option>
                                    <option value="copinoContNo">{{ $t('copinoSend4') }}</option>
                                    <option value="sendID">{{ $t('copinoSend5') }}</option>
                                </select>
                                <input v-if="this.searchType == 'carNo'" type="text" class="form-control" v-model="carNo" maxlength="9"  :placeholder="$t('copinoSend7')" @keyup.enter="copinoSend">
                                <input v-if="this.searchType == 'copinoContNo'" type="text" class="form-control" v-model="copinoContNo" maxlength="11" :placeholder="$t('copinoSend8')" @keyup.enter="copinoSend">
                                <input v-if="this.searchType == 'sendID'" type="text" class="form-control" v-model="sendID" maxlength="8" :placeholder="$t('copinoSend9')" @keyup.enter="copinoSend">
                                <button class="searchButton" @click="copinoSend"><i class="bi bi-search"></i></button>
                            </div>
                        </div>
                        <div class="col-lg-4 order-1 order-lg-2 text-center">
                            <img v-bind:src="tabSearch" alt="" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script src="@/assets/js/Home/MainInfo.js"></script>
<style scoped>
.more{
    float: right;
    font-weight: bold;
    cursor: pointer;
}
#features{
    padding: 0 0 60px;
}
.table{
    text-align: center
}
.subject{
    cursor:pointer;
    color: black
}
.img-fluid{
    min-height: 350px;
}
.searchButton{
  background: none;
  font-size: 16px;
  padding: 0 15px;
  margin: -1px;
  background: var(--color-primary);
  color: var(--color-white);
  transition: 0.3s;
  border-radius: 0 4px 4px 0;
  line-height: 0;
  border: 0;
  float: right;
}
.form-select{
 width: 20%;
 border-radius: 0;
 margin: 0;
}
.form-control{
    border-radius: 0;
}
.col-md-2 {
text-align: center;
}
.icon {
    background-color: #f5f6f8;
    width: 60px;
    height: 60px;
    border-radius: 500px;
    text-align: center;
}
.iconBox{
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
